import { TmBaseError } from '@/core/error/tmBaseError'

export default class TmLogicError extends TmBaseError {
  public name = 'TmLogicError'
}
